export enum CartRefreshActionType {
  EMIT_EVENT = "emit-event",
  CALL_FUNCTION = "call-function",
  REFRESH_PAGE = "refresh-page",
}

/**
 * A theme-refresh step run after Redo is added to or removed from the cart.
 * Defined actions replace the built-in per-theme refresh hooks.
 */
export interface CartRefreshAction {
  type: CartRefreshActionType;
  /** Event name for EMIT_EVENT; global function name for CALL_FUNCTION. */
  value?: string;
}
